import { render, staticRenderFns } from "./PaymentPassword.vue?vue&type=template&id=ff20bc94"
import script from "./PaymentPassword.vue?vue&type=script&lang=js"
export * from "./PaymentPassword.vue?vue&type=script&lang=js"
import style0 from "./PaymentPassword.vue?vue&type=style&index=0&id=ff20bc94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports